import { sectionHeader } from './index';

export const credibility = (bid) => {
  const result = [];
  const {
    showBasic,
    showNumbers
  } = bid.template.credibility;

  if (showBasic || showNumbers) {
    result.push({ margin: [0, 20, 0, 0], text: "" });
    result.push(sectionHeader("Terms and Conditions"));

    const content = {
      margin: [10, 0, 10, 0],
      stack: [],
    };

    showBasic && content.stack.push(getBasic(bid));
    showNumbers && content.stack.push(getNumbers(bid));

    result.push(content);
  }

  return result;
};

const getBasic = (bid) => ([
  { text: "Notes", style: "label" },
  { text: bid.notes },
  { text: "", margin: [0, 0, 0, 15] },
  { text: "Terms", style: "label" },
  { text: bid.terms },
  { text: "", margin: [0, 10, 0, 15] },
  { text: "Thank you for your business!", alignment: "center" },
]);

const getNumbers = (bid) => ({
  alignment: "right",
  stack: [
      { text: "Tax Number", style: "label" },
      { text: bid.taxNumber },
      { text: "Company Number", style: "label" },
      { text: bid.companyNumber }
  ]
});



// WEBPACK FOOTER //
// ./src/store/generators/PDF/bid/credibility.js